function CONNECTFooter() {
  return (
    <>
      <footer id="GlobalFooter" />
    </>
  );
}

export default CONNECTFooter;
